/** 最终输出：曝光 × ACES 色调映射 × sRGB 编码 */

export const tonemapShader = /* glsl */ `
precision highp float;
uniform sampler2D uScene;
uniform sampler2D uAdapt; // 1x1，g 通道为曝光值
uniform float uManualExposure;
varying vec2 vUv;

vec3 aces(vec3 x) {
  const float a = 2.51;
  const float b = 0.03;
  const float c = 2.43;
  const float d = 0.59;
  const float e = 0.14;
  return clamp((x * (a * x + b)) / (x * (c * x + d) + e), 0.0, 1.0);
}

void main() {
  vec3 c = texture2D(uScene, vUv).rgb;
  float exposure = texture2D(uAdapt, vec2(0.5)).g * uManualExposure;
  c *= exposure;
  c = aces(c);
  c = pow(c, vec3(1.0 / 2.2));
  gl_FragColor = vec4(c, 1.0);
}
`
